module.exports = __webpack_public_path__ + "media/images/chat-edit-active-d0f30c8b.svg";